import { Action, createReducer, on } from '@ngrx/store';
import {
  policyAcceptanceAction,
  policyAcceptanceFailureAction,
  policyAcceptanceSuccessAction,
} from './policy-acceptance.actions';
import { PolicyAcceptanceState } from './policy-acceptance.types';

const initialState: PolicyAcceptanceState = {
  loading: false,
};

const policyAcceptanceReducer = createReducer(
  initialState,
  on(policyAcceptanceAction, (state, action) => ({
    ...state,
    loading: true,
    userId: action.userId,
    accepted: undefined,
  })),
  on(policyAcceptanceSuccessAction, (state, action) => ({
    ...state,
    loading: false,
    userId: action.userId,
    accepted: true,
  })),
  on(policyAcceptanceFailureAction, (state, action) => ({
    ...state,
    loading: false,
    userId: action.userId,
    accepted: false,
  })),
);

export const reducer = (state: PolicyAcceptanceState, action: Action) => policyAcceptanceReducer(state, action);
